import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface CreateLoginForm {
  email: string
  password: string
  passwordConfirm: string
}

export const CreateLoginFormValues: CreateLoginForm = {
  email: '',
  password: '',
  passwordConfirm: '',
}

export interface ICreateLoginState {
  loginForm: CreateLoginForm
}

const initialState: ICreateLoginState = {
  loginForm: CreateLoginFormValues,
}

export const slice = createSlice({
  name: 'createLogin',
  initialState,
  reducers: {
    onLoginForm: (
      state: ICreateLoginState,
      action: PayloadAction<typeof initialState.loginForm>
    ) => {
      state.loginForm = action.payload
    },
  },
})

export const { actions, reducer } = slice

export type ICreateLogin = {
  createLogin: ICreateLoginState
}
